<template>
  <div class="fullscrean">
    <div>
      <img src="../assets/logo-lecard.png" class="img-fluid" alt="Logo Lecard" style="width: 96px">
      <div class="mt-4">
        <h5 class="mb-3 font-weight-bold">Sistema pausado por falta de pagamento</h5>
        <p class="mb-4" style="max-width: 500px">
          Em caso de dúvidas, entre em contato com o nosso Financeiro pelo Telefone e/ou WhatsApp: <span class="text-nowrap">(16) 98815-6773</span>
        </p>
        <div>
          <a href="https://wa.me/5516988156773" target="_blank" class="btn btn-primary">Entrar em contato</a>
        </div>
        <div class="mt-4">
          <a href="javascript:" class="btn text-dark" @click="confirmLogout()">Sair do sistema</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  export default {
    name: 'Block',
    components: {TopBar},

    methods: {
      confirmLogout() {
        this.$swal({
          text: "Deseja sair do sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.logout(true);
          }
        });
      },
    },

    mounted() {
      if (this.$store.state.dataUser.status_empresa === '2') {
        this.$router.push('/');
      }
    }
  }
</script>

<style scoped>
</style>
